type ReportModule = typeof import('../../pages/user/Assessments/AssessmentReportPage')

let loaded: ReportModule | undefined
let pending: Promise<ReportModule> | undefined

/** Share the route's resolved component with the overview's preloader. */
export function loadReportPage(): Promise<ReportModule> {
  pending ??= import('../../pages/user/Assessments/AssessmentReportPage').then(module => {
    loaded = module
    return module
  }).catch(error => {
    pending = undefined
    throw error
  })
  return pending
}

export const getLoadedReportPage = () => loaded?.default
